
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Search, X } from 'lucide-react';
import { TaskFilters as TaskFiltersType } from '@/types/taskFilters';

interface TaskFiltersProps {
  filters: TaskFiltersType;
  onFiltersChange: (filters: Partial<TaskFiltersType>) => void;
  onReset: () => void;
}

const TaskFilters = ({ filters, onFiltersChange, onReset }: TaskFiltersProps) => {
  return (
    <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 w-full">
      <div className="relative w-full sm:flex-1">
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
        <Input
          type="search"
          placeholder="Search tasks..."
          className="w-full pl-8"
          value={filters.search}
          onChange={(e) => onFiltersChange({ search: e.target.value })}
        />
      </div>
      
      <Select 
        value={filters.priority} 
        onValueChange={(value) => onFiltersChange({ priority: value })}
      >
        <SelectTrigger className="w-full sm:w-[180px]">
          <SelectValue placeholder="Priority" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Priorities</SelectItem>
          <SelectItem value="high">High</SelectItem>
          <SelectItem value="medium">Medium</SelectItem>
          <SelectItem value="low">Low</SelectItem>
        </SelectContent>
      </Select>

      <Select 
        value={filters.dueDate} 
        onValueChange={(value) => onFiltersChange({ dueDate: value })}
      >
        <SelectTrigger className="w-full sm:w-[180px]">
          <SelectValue placeholder="Due Date" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Due Dates</SelectItem>
          <SelectItem value="today">Due Today</SelectItem>
          <SelectItem value="tomorrow">Due Tomorrow</SelectItem>
          <SelectItem value="week">Due This Week</SelectItem>
          <SelectItem value="month">Due This Month</SelectItem>
        </SelectContent>
      </Select>

      {(filters.search || filters.priority !== 'all' || filters.dueDate !== 'all') && (
        <Button 
          variant="ghost" 
          size="icon"
          onClick={onReset}
          className="self-center"
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
};

export default TaskFilters;
